/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PigDto } from '../../models/pig-dto';
import { PigUpdateDto } from '../../models/pig-update-dto';

export interface PigControllerUpdate$Params {
  id: string;
      body: PigUpdateDto
}

export function pigControllerUpdate(http: HttpClient, rootUrl: string, params: PigControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<PigDto>> {
  const rb = new RequestBuilder(rootUrl, pigControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PigDto>;
    })
  );
}

pigControllerUpdate.PATH = '/api/pig/{id}';
